import {
  PopulatingDashboardCounts,
  TableAndCountResponse,
  TablesAndCountsResponse,
} from "./types";
import { httpClient } from "./httpClient";

type Response = {
  counts: PopulatingDashboardCounts;
};

export async function getUserDashboard(
  startDate: string,
  endDate: string
): Promise<PopulatingDashboardCounts> {
  try {
    const { data } = await httpClient.get<Response>(
      `/api/v1/dashboard?startDate=${startDate}&endDate=${endDate}`
    );
    return data.counts;
  } catch (error) {
    throw error;
  }
}

export const getAdminMaintenance = async (): Promise<
  TableAndCountResponse[]
> => {
  try {
    const { data } = await httpClient.get<TablesAndCountsResponse>(
      `/api/v1/admin/maintenance`
    );
    return data.tablesAndCounts;
  } catch (err) {
    console.error("Error: ", err);
    throw err;
  }
};
